export const addPurchaseParams = {
  promotionId: 'promotionId',
  ruleId: 'ruleId',
  grades: 'gradeId',
  courseTypes: 'courseType',
  subjects: 'subjectId',
  textbookContents: 'textbookContentId',
  terms: 'termId',
  versions: 'versionId',
  studyPhases: 'studyPhaseId',
  progresses: 'progressId',
  difficulties: 'difficultyId',
  times: 'timeId',
  timeSlots: 'timeSlotId',
  knowledges: 'knowledgeId',
  labels: 'labelId'
}



// WEBPACK FOOTER //
// ./src/defines/addPurchaseParams.js